import { Fragment, useEffect } from 'react';

export const ScrollToTop = (props) => {
  useEffect(() => {
    window.scrollTo({ top: 200, behavior: 'smooth' });
  }, []);

  return <Fragment>{props.children}</Fragment>;
};
